import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OutlookCalenderComponent } from './outlook-calender.component';

const routes: Routes = [{ path: '', component: OutlookCalenderComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OutlookCalenderRoutingModule { }
